/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-03 09:30:28
 * @Description: 
 */
import { Input } from "antd";
import React from "react";
import { IconClose } from "src/assets";
import ToolLeftSearchTags from "./ToolLeftSearchTags/ToolLeftSearchTags"
import "./ToolLeftSearch.scss"
import { useSearchText } from "src/hooks";
import FTImageStore from "src/store/FTImageStore";
import FTLang from "src/utils/FTLang";
import clsx from "clsx";
export default function ToolLeftSearch() {
  let [searchText, setSearchText] = useSearchText()
  let [inputValue, setInputValue] = React.useState("")
  let updateTimer = React.useRef<any>(null)
  const handleClear = () => {
    setSearchText("")
    if(FTImageStore.selectEffectTags && FTImageStore.selectEffectTags.length) {
      FTImageStore.clearSelectTags()
    }
    FTImageStore.searchList = []
  }

  React.useEffect(() => {
    setInputValue(searchText)
  }, [searchText])

  const handleChange = (value: any) => {
    setInputValue(value.target.value)
    if(updateTimer.current) {
      clearTimeout(updateTimer.current)
      updateTimer.current = null
    }
    updateTimer.current = setTimeout(() => {
      setSearchText(value.target.value)
      if(FTImageStore.selectEffectTags.length) {
        FTImageStore.clearSelectTags()
      }
    }, 1000)
  }

  const handleFocus = (e: any) => {
    e.target.setAttribute("autocomplete", "off")
    if(FTImageStore.selectEffectTags.length) {
      setInputValue("")
    }
  }

  const handleBlur = () => {
    if(FTImageStore.selectEffectTags.length) {
      setInputValue(searchText)
    }
  }

  return <div className="toolleft_search">
    <Input
      className={clsx(!inputValue && "toolleft_search_empty", "toolleft_search_input")}
      onFocus={handleFocus}
      onBlur={handleBlur}
      value={inputValue}
      onChange={handleChange}
      style={{ width: '100%' }}
      suffix={<IconClose className={clsx("icon_close", !inputValue && "icon_close_hide")} style={{width: "10px", height: "10px"}} onClick={handleClear} />}
      placeholder={FTLang._("goart_search_placeholder")}
    />
    <ToolLeftSearchTags />
  </div>
}